import { useId as useIdReact } from 'react';

const INVALID_CHARS_REGEXP = /[^\w-]/g;

/**
 * Wrapper for React's `useId` that forces a prefix and removes characters
 * that are not allowed in APIs like querySelector and CSS.
 *
 * https://github.com/facebook/react/issues/26839
 */
export function useId(prefix: string) {
	const reactId = useIdReact();
	return `${prefix}-${reactId.replaceAll(INVALID_CHARS_REGEXP, '__')}`;
}
